import { Event } from '@/event-bus/event';

export class MassReviewTransitionsFailedEvent extends Event<Error> {}
